class modalInvoiceTitleModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest,logger) {
        $scope.selectedUploadRows = [];
        // 分页
        $scope.totalItems = 0;
        $scope.sytotalItems = 0;
        $scope.pageRequestDTO = '';
        $scope.wsypageRequestDTO = {
            pageNum: 1,
            pageSize: 10,
            param: {
                custName: '',
                creditCode: '',
                mobile: '',
                startDate: '',
                endDate: '',
                departmentName:'',
                useStatus: '0',
            },
        };
        $scope.sypageRequestDTO = {
            pageNum: 1,
            pageSize: 10,
            param: {
                custName: '',
                creditCode: '',
                mobile: '',
                startDate: '',
                endDate: '',
                departmentName:'',
                useStatus: '1',
            },
        };
        // 表头排序
        $scope.orderMap={}
        $scope.selectedHandle = function (res) {
            if($scope.orderMap.sortVal){
                let orderMap={}
                orderMap[$scope.orderMap.sortKey]=$scope.orderMap.sortVal
                $scope.pageRequestDTO.orderMap=orderMap
            }else{
                $scope.pageRequestDTO.orderMap={}
            }
            $scope.getData()
        };
        $scope.getData = function getData() {
            httpRequest.post_getSysDepartmentQrCust($scope.pageRequestDTO).then(res => {
                if (res.data.success) {
                    $scope.pageRequestDTO.pageNum = ++res.data.value.prePage;
                    $scope.pageRequestDTO.pageSize = res.data.value.pageSize;
                    if ($scope.tab == 1) {
                        $scope.sytotalItems = res.data.value.total;
                        $scope.list = res.data.value.list;
                    } else {
                        $scope.totalItems = res.data.value.total;
                        $scope.list = res.data.value.list;
                    }
                }
            });
        };
        $scope.reset = function reset() {
            $scope.pageRequestDTO = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    custName: '',
                    creditCode: '',
                    mobile: '',
                    startDate: '',
                    endDate: '',
                    useStatus:  $scope.tab,
                },
            };
            if ($scope.tab == 0) {
                $scope.wsypageRequestDTO = $scope.pageRequestDTO;
            } else {
                $scope.sypageRequestDTO = $scope.pageRequestDTO;
            }
        };
        $scope.tableDropdownConfig = [
            {
                label: '删除',
                handler(item) {
                    httpRequest.del_sysDepartmentQrCust([item.custId],'删除成功').then(res=>{
                        $scope.getData()
                    })
                },
                showWhile(item, hasPermit) {
                    return true;
                },
            },
        ];
        
        $scope.tabChange = function tabChange(v) {
            if($scope.tab==v)return
            $scope.tab = v;
            $scope.list=[]
            $scope.orderMap={}
            $scope.selectedUploadRows=[]
            if (v == 0) {
                if ($scope.pageRequestDTO) {
                    $scope.sypageRequestDTO = $scope.pageRequestDTO;
                }
                $scope.pageRequestDTO = $scope.wsypageRequestDTO;
                if($scope.wsypageRequestDTO.orderMap&&JSON.stringify($scope.wsypageRequestDTO.orderMap)!='{}'){
                    let key=Object.keys($scope.wsypageRequestDTO.orderMap)[0]
                    $scope.orderMap.sortKey=key
                    $scope.orderMap.sortVal=$scope.wsypageRequestDTO.orderMap[key]
                }
            } else {
                $scope.wsypageRequestDTO = $scope.pageRequestDTO;
                $scope.pageRequestDTO = $scope.sypageRequestDTO;
                if($scope.sypageRequestDTO.orderMap&&JSON.stringify($scope.sypageRequestDTO.orderMap)!='{}'){
                    let key=Object.keys($scope.sypageRequestDTO.orderMap)[0]
                    $scope.orderMap.sortKey=key
                    $scope.orderMap.sortVal=$scope.sypageRequestDTO.orderMap[key]
                }
            }
            $scope.getData();
        };
        $scope.deleteHandle= function deleteHandle(){
           if($scope.selectedUploadRows.length==0){
            logger.logError('请选择至少一条数据')
            return
           } 
           let idList=[]
           $scope.selectedUploadRows.forEach(item=>{
               idList.push(item.custId)
           })
           httpRequest.del_sysDepartmentQrCust(idList,'删除成功').then(res=>{
            $scope.getData()
        })
        }
        $scope.cancel = () => {
            $uibModalInstance.close();
        };
        $scope.ok = (item) => {
           httpRequest.get_updateForUsed(item.custId).then(res=>{
                $uibModalInstance.close(item)
           })
        };
        $scope.pageChanged=function pageChanged(){
            $scope.getData()
        }
    }
}

modalInvoiceTitleModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest','logger'];
export default modalInvoiceTitleModalCtrl;



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/invoiceTitleModalCtrl.js